export default __webpack_public_path__ + "static/media/shirts.efec4b31.webp";